module.exports = __webpack_public_path__ + "img/bo.a2b75037.png";